import React from 'react';
const MenuContext = /*#__PURE__*/React.createContext({
  getItemProps: () => ({
    isSelected: false,
    onSelected: () => {},
    props: {}
  }),
  selectedItem: null,
  selectionStyle: 'tick'
});
export const MenuContextProvider = MenuContext.Provider;
export const useMenuContext = () => React.useContext(MenuContext);